import { useVentas  } from "../contexto/provider/VentasContext.js";

export function useVentasConfirmadas() {
  const { ventas, loading, cargarVentas } = useVentas(); // extrae el contexto completo
  const confirmadas = ventas.filter(v => v.estado === "pagada");
  return { ventas: confirmadas, loading , cargarVentas}; // devuelve solo lo necesario para este hook
}
